<data>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{ transactionProduct?.productName }}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="12" ngbAutofocus>
    <form #transactionForm="ngForm">
      <div class="row">
        <div class="col-xl-2 col-md-8 col-12 ">
          <label for="count">Miktar <span *ngIf="transactionProduct?.productType">({{transactionProduct?.unitTypeName}})</span></label>
          <div class="form-group">
            <input type="number" class="form-control" id="productCount" name="productCount"
              [disabled]="selectedSerialIds.length" [(ngModel)]="transactionProduct.productCount"
              (ngModelChange)="calculateTotalPrice(); allFieldsFilled()" />
          </div>
        </div>
        <div class="col-xl-10 col-md-8 col-12" *ngIf="transactionProduct.productType">
          <label for="customSelect">Depo</label>
          <div class="form-group">
            <select class="form-control" id="customSelect" (change)="onWarehouseChange($event); allFieldsFilled()">
              <option *ngFor="let item of warehouses" [selected]="item.id == transactionProduct.warehouseId"
                [value]="item.id">{{item.warehouseName}}
                ({{ getProductCountDifference(item.id) }} Adet)</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-md-8 col-12">
          <label for="salePrice">Satış Fiyatı</label>
          <div class="form-group">
            <div class="row">
              <div class="col-6 pr-0">
                <input type="number" class="form-control" id="productPrice" name="productPrice"
                  [(ngModel)]="transactionProduct.productPrice"
                  (ngModelChange)="calculateTotalPrice(); allFieldsFilled()" />
              </div>
              <div class="col-6 pl-0">
                <select class="form-control" id="currencySelect"
                  (change)="onCurrencySelect($event); allFieldsFilled();">
                  <option *ngFor="let item of currencies" [value]="item.id"
                    [selected]="transactionProduct.currencyId == item.id">
                    {{item.currencyName}}
                  </option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="col-xl-2 col-md-8 col-12">
          <label for="saleTaxId">Kdv</label>
          <div class="form-group">
            <select class="form-control" id="saleTaxId" (change)="onSaleTaxChange($event)">
              <option *ngFor="let item of allTax" [value]="item.id" [selected]="transactionProduct.taxId == item.id">
                {{item.taxRate}}</option>
            </select>
          </div>
        </div>
        <div class="col-xl-3 col-md-8 col-12">
          <label for="discountRate">İndirim</label>
          <div class="form-group">
            <div class="input-group">
              <input type="number" class="form-control" id="discountRate" name="discountRate"
                [(ngModel)]="transactionProduct.discountRate"
                (ngModelChange)="calculateTotalPrice(); allFieldsFilled()" />
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-8 col-12 ">
          <label for="total">Toplam</label>
          <div class="form-group">
            <input type="number" class="form-control" id="total" name="total" [(ngModel)]="total"
              (ngModelChange)="calculateSalePriceFromTotal()" />
          </div>
        </div>
        <div class="col-xl-12 col-12"
          *ngIf="transactionProduct.transactionManagementKindId == 6 || transactionProduct.transactionManagementKindId == 5">
          <label>Seri Numaraları</label>
          <div class="form-group">
            <div *ngFor="let serial of transactionProduct.productSerials">
              <label>
                <input type="checkbox" [checked]="isSerialChecked(serial.id)"
                  (change)="onCheckboxChange(serial.id, $event)" />
                {{ serial.serialNo }}
              </label>
            </div>
          </div>
        </div>

        <div class="row col-12 mt-2 d-flex">
          <div class="feature-item col-xl-3 col-md-6 col-sm-12" *ngFor="let item of features">
            <ng-template [ngIf]="!transactionProduct.productType">
              <label>{{ item.name }}</label>
              <select class="form-control" [(ngModel)]="item.value" name="feature-{{ item.id }}"
                (change)="updateSelectedFeatures()">
                <option [value]="true">Evet</option>
                <option [value]="false">Hayır</option>
              </select>
            </ng-template>
          </div>
        </div>

        <div class="row mt-1 col-12">
          <div *ngFor="let variant of allVariants" [ngClass]=" variant.variantType===3 ? 'col-xl-4 col-md-6 col-sm-12'
            : 'col-xl-4 col-md-6 col-sm-12'">
            <!-- Gözüksün mü? (DisplayColonOrName) -->
            <!-- <div class="d-flex align-items-center mb-50">
              <input type="checkbox" [checked]="(variant.displayType === 3 ||variant.displayType == 2)"
                (change)="variant.displayType = $event.target.checked ? 2 : 1" />
              <span class="ml-1">Gözüksün mü?</span>
            </div> -->

            <div>
              <div class="d-flex align-items-center mb-50">
                <i class="feather"
                  [ngClass]="variant.displayType === 3 || variant.displayType === 2 ? 'icon-eye' : 'icon-eye-off'"
                  (click)="variant.displayType = (variant.displayType === 3 || variant.displayType === 2) ? 1 : 2"
                  style="cursor: pointer;" title="Tabloda gözükmesini istiyorsan aktif bırak"></i>

                <label class="fw-bold mb-0 ml-25">
                  {{ variant.name }}
                </label>

              </div>

              <ng-container *ngIf="variant.variantType === 1">
                <select class="form-control" [(ngModel)]="variant.selectedOptionId"
                  (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let opt of variant.productVariantOptions" [value]="opt.id">
                    {{ opt.name }}
                  </option>
                </select>
              </ng-container>

              <!-- 2 → Checkbox -->
              <ng-container *ngIf="variant.variantType === 2">
                <!-- <div class="form-check">
                  <input type="checkbox" class="form-check-input" [(ngModel)]="variant.valueBool"
                    (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}" />
                  <label class="form-check-label"></label>
                </div> -->


                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="variant.valueBool"
                    (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}" />
                  <label class="custom-control-label" for="customCheck1">Evet / Hayır</label>
                </div>

                <div *ngIf="variant.valueBool && variant.trueLabel" class="text-success small">
                  ({{ variant.trueLabel }})
                </div>
                <div *ngIf="!variant.valueBool && variant.falseLabel" class="text-danger small">
                  ({{ variant.falseLabel }})
                </div>
              </ng-container>

              <!-- 3 → Input -->
              <ng-container *ngIf="variant.variantType === 3">
                <input type="text" class="form-control" [(ngModel)]="variant.valueText"
                  (ngModelChange)="checkRequiredVariantsFilled()" [ngModelOptions]="{standalone: true}"
                  placeholder="Değer giriniz..." />
              </ng-container>
            </div>
          </div>
        </div>

        <div class="col-xl-12 col-md-8 col-12 mt-1">
          <label for="description">Açıklamalar</label>
          <div class="form-group">
            <div *ngFor="let desc of transactionProduct.transactionProductDescriptions; let i = index"
              class="input-group mb-2">
              <input type="text" class="form-control" [(ngModel)]="desc.description" [name]="'description' + i" />
              <div class="input-group-append">
                <button type="button" class="btn btn-danger" (click)="removeDescription(i)">Kaldır</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <button type="button" class="btn btn-primary ml-1" (click)="addDescription()"><i
            data-feather="plus"></i></button> -->
        <button type="button" class="btn btn-success ml-auto mr-1" (click)="updateTransactionProduct()"
          [disabled]="!allFieldsFilled()"
          *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateTransactionProducts')">Güncelle</button>
      </div>
    </form>
  </div>
</data>